import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { memo } from "react"

interface BreadcrumbsButtonProps {
    text: string
    url?: string
}

const BreadcrumbsButton: React.FC<BreadcrumbsButtonProps> = ({ text, url }) => {

    const { t } = useTranslation()

    if (url) {
        return (
            <Link to={url} className={`breadcrumbs-button ${!text && 'skeleton'}`}>
                <div className={`breadcrumbs-button-text`}>{t(text)}</div>
                <div className={`breadcrumbs-button-arrow`}></div>
            </Link>
        )
    } else {
        return (
            <div className={`breadcrumbs-button ${!text && 'skeleton'} !cursor-default`}>
                <div className={`breadcrumbs-button-text`}>{t(text)}</div>
                <div className={`breadcrumbs-button-arrow`}></div>
            </div>
        )
    }
}

export default memo(BreadcrumbsButton)

